import React, { Component } from 'react';
import { Switch, Route } from 'react-router';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AllContacts from '../contacts/AllContacts';
import NewContact from '../contacts/NewContact';
import ImportContact from '../contacts/ImportContact';
import ContactDetail from '../contacts/ContactDetail';
import { bindActionCreators } from 'redux';
import { addNotificationAction } from '../../actions/Actions';

class Contact extends Component {
  render() {
    const { lang, addNotification } = this.props;

    return (
      <Switch>
        <Route
          path="/phonebook/contacts/create"
          component={() => <NewContact lang={lang} addNotification={addNotification} />}
        />

        <Route
          path="/phonebook/contacts/edit/:slug"
          render={({ match }) => {
            const slug = match.params.slug;
            if (slug) {
              return <NewContact lang={lang} addNotification={addNotification} slug={slug} />;
            }
          }}
        />

        <Route
          exact
          path="/phonebook/contacts/import"
          component={() => <ImportContact lang={lang} addNotification={addNotification} />}
        />

        <Route
          path="/phonebook/contacts/:slug"
          render={({ match }) => {
            const slug = match.params.slug;
            if (slug) {
              return <ContactDetail lang={lang} slug={slug} addNotification={addNotification} />;
            }
          }}
        />

        <Route
          component={() => <AllContacts lang={lang} addNotification={addNotification} />}
        />
      </Switch>
    );
  }
}

export default withRouter(connect(
  state => ({
    lang: state.lang
  }),
  dispatch => ({
    addNotification: bindActionCreators(addNotificationAction, dispatch),
  })
)(Contact));
